import { Component, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { UiButton } from '@shared/components/ui';
import { form, FormField, required, min } from '@angular/forms/signals';
import { IProductoLibre } from '@core/interfaces/producto.libre.interface';
import { FormErrorMessagePipe } from '../../pipes/form-error-message.pipe';

@Component({
  selector: 'app-agregar-producto-libre',
  imports: [
    UiButton,
    FormField,
    FormErrorMessagePipe,
  ],
  templateUrl: './agregar-producto-libre.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agregar-producto-libre.css',
})
export class AgregarProductoLibre {
  formData = form(
    signal({
      nombre: '',
      precio: 1,
      cantidad: 1,
    }),
    (schemaPath) => {
      required(schemaPath.nombre, { message: 'El nombre del producto es requerido' });
      required(schemaPath.precio, { message: 'El precio del producto es requerido' });
      required(schemaPath.cantidad, { message: 'La cantidad del producto es requerida' });
      min(schemaPath.precio, 0.1, { message: 'El precio debe ser mayor a 0' });
      min(schemaPath.cantidad, 1, { message: 'La cantidad debe ser al menos 1' });
    },
  );

  agregarProducto = output<IProductoLibre>();
  onAgregarProducto() {
    if (!this.formData().controlValue().nombre || this.formData().controlValue().precio <= 0) {
      this.formData().markAsTouched();
      return;
    }
    const producto: IProductoLibre = {
      nombre: this.formData().controlValue().nombre,
      precio: this.formData().controlValue().precio,
      cantidad: this.formData().controlValue().cantidad,
    };
    this.agregarProducto.emit(producto);
    this.restart();
  }

  restart() {
    this.formData().reset({
      nombre: '',
      precio: 1,
      cantidad: 1,
    });
  }
}
